<template>
    <ModalBase
        :name="'anular-' + abonado.id"
        :title="'Devolver abono de ' + abonado.name + ' ' + abonado.surnames"
        @closed="onClosed"
    >
        <!-- Datos del abonado -->
        <fieldset class="tw:border tw:border-gray-200 tw:rounded-xl tw:p-4 tw:mb-6">
            <legend class="tw:text-sm tw:font-semibold tw:text-gray-500 tw:uppercase tw:tracking-wide tw:px-2">
                Datos del abonado
            </legend>

            <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-x-6 tw:gap-y-3">
                <DataField label="Nº de abonado" :value="abonado.n_abonado" />
                <DataField label="Nombre" :value="abonado.name" />
                <DataField label="Apellidos" :value="abonado.surnames" />
                <DataField label="DNI" :value="abonado.dni" />
                <DataField label="Email" :value="abonado.email" />

                <DataField label="Asiento" wrapperClass="tw:md:col-span-2">
                    <template v-if="abonado.tiene_asiento || abonado.plaza">
                        <p class="tw:text-sm tw:font-medium tw:m-0 tw:text-gray-800">
                            <template v-if="abonado.tiene_asiento">
                                Zona: {{ abonado.asiento.region }}, Fila: {{ abonado.asiento.row }}, Butaca: {{ abonado.asiento.seat }}
                            </template>
                            <template v-else-if="abonado.plaza">
                                {{ abonado.plaza.region_name ? abonado.plaza.region_name + ', ' : '' }}Fila: {{ abonado.plaza.fila }}, Butaca: {{ abonado.plaza.butaca }}
                            </template>
                        </p>
                    </template>
                    <template v-else>
                        <p class="tw:text-sm tw:font-medium tw:m-0 tw:text-gray-400">Sin asiento</p>
                    </template>
                </DataField>
            </div>
        </fieldset>

        <!-- Confirmación -->
        <div v-if="!anulado" class="tw:w-full tw:flex tw:justify-end">
            <Button
                :loading="loading"
                :disabled="loading"
                variant="danger"
                @click.prevent="anularAbonado"
            >
                {{ loading ? 'Anulando...' : 'SI, ANULAR' }}
            </Button>
        </div>

        <div v-else class="tw:text-center">
            <h2 class="tw:text-xl tw:font-bold tw:text-green-600">ANULADO</h2>
        </div>
    </ModalBase>
</template>

<script setup>
    import { ref, getCurrentInstance } from 'vue';
    import store from '@/store';
    import { useToast } from '@/composables/common/useToast';
    import { config } from '@/config';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import DataField from '@/modules/admin/ui/DataField.vue';

    const props = defineProps({
        abonado: { type: Object, required: true },
    });

    const emit = defineEmits(['close']);
    const toast = useToast();
    const instance = getCurrentInstance();
    const modalName = `anular-${props.abonado.id}`;

    const loading = ref(false);
    const anulado = ref(false);

    function close() {
        instance.proxy.$modal.hide(modalName);
    }

    function onClosed() {
        emit('close', modalName, anulado.value);
    }

    async function anularAbonado() {
        if (loading.value) return;
        loading.value = true;

        try {
            const params = {
                filters: {},
                abonado_id: props.abonado.id,
            };

            await store.dispatch(config.getVuexAlias('back.abonados.anular'), params);

            anulado.value = true;
            toast.success('Abonado anulado');

            // Auto-close after a brief delay so the user sees the confirmation in the modal.
            setTimeout(close, 500);
        } catch {
            toast.error('Error al anular el abonado');
        } finally {
            loading.value = false;
        }
    }
</script>
